export const CUSTOM_PAYOUT_ADVERTISER_IDS = [141, 190, 193];
export const CUSTOM_RULES_ADVERTISER_IDS =  [15, 141, 190, 193];

// const PAGSEGURO_ID       = 15;
// const ABERTURA_CONTA_ID  = 141;
// const CONTA_PJ_ID        = 190;
// const TAP_ON_ID          = 193;

export function isAdvertiserCustomPayout(advertiserId) {
  if (!advertiserId) return false;
  return CUSTOM_PAYOUT_ADVERTISER_IDS.includes(advertiserId);
}

export function isAdvertiserCustomRules(advertiserId) {
  if (!advertiserId) return false;
  return CUSTOM_RULES_ADVERTISER_IDS.includes(advertiserId);
}